import { IProjectTemplate } from '@d-id/types';
import { useMemo } from 'react';

interface Props {
    templates: IProjectTemplate[];
    search?: string;
    tagFilter?: string;
    aspectRatio?: string;
}

export const useTemplateFilters = ({ templates = [], search = '', tagFilter = 'all', aspectRatio }: Props) => {
    const filteredByAspectRatioTemplates = useMemo(() => {
        if (!aspectRatio) return templates;
        return templates.filter(template => template.cropMode === aspectRatio);
    }, [templates, aspectRatio]);

    const filteredTemplates = useMemo(() => {
        return filteredByAspectRatioTemplates.filter(template => {
            const matchesSearch = search ? template.name.toLowerCase().includes(search.toLowerCase()) : true;
            const matchesTag = !tagFilter || tagFilter === 'all' || template.tags.includes(tagFilter);

            return matchesSearch && matchesTag;
        });
    }, [filteredByAspectRatioTemplates, search, tagFilter]);

    return { filteredTemplates, filteredByAspectRatioTemplates };
};
